const IS_SEND_MAIL = false;
const SEND_TIME = "20:00";
const INITAL_DAYS = [
  {
    days: 0,
    isSend: false,
  },
  {
    days: 1,
    isSend: false,
  },
  {
    days: 2,
    isSend: false,
  },
  {
    days: 3,
    isSend: false,
  },
  {
    days: 4,
    isSend: false,
  },
  {
    days: 5,
    isSend: true,
  },
  {
    days: 6,
    isSend: false,
  },
];
const weekDays = ["日", "月", "火", "水", "木", "金", "土"];

const timeTable = () => {
  const timeTable = [];
  let hour = 0; // 開始時間
  let minute = 0; // 開始分

  while (hour < 24) {
    // 時間をフォーマットして配列に追加
    const time = `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
    timeTable.push({
      id: time,
      name: time,
    });

    // 30分を追加
    if (minute === 30) {
      hour += 1;
      minute = 0;
    } else {
      minute = 30;
    }
  }
  return timeTable;
};

export { IS_SEND_MAIL, SEND_TIME, timeTable, INITAL_DAYS, weekDays };
